<!--Banner-->
<ng-container *ngIf="memberDetails$ | async as memberDetails">
  <ng-container *notInPopulation="[populations.JuniorBluebirds]">
    <fgb-banner
      [title]="('home.page.banner' | translate) + ', ' + memberDetails.FirstName + '!'"
      [isHomePage]="true"
      [memberId]="memberDetails.MemberId"
      class="d-none d-lg-block"
    ></fgb-banner>
  </ng-container>
  <ng-container *inPopulation="[populations.JuniorBluebirds]">
    <fgb-banner [isImageBanner]="true" [imageBannerUrl]="'banners/kids-home-banner.jpg'" class="d-lg-flex d-none"></fgb-banner>
  </ng-container>
</ng-container>

<!--Member Card-->
<div class="d-block d-lg-none">
  <fgb-mobile-nav-menu></fgb-mobile-nav-menu>
  <fgb-mobile-page-header [isHomePage]="true"></fgb-mobile-page-header>
  <fgbcl-loyalty-feed-list></fgbcl-loyalty-feed-list>
</div>

<!--Scorecards carousel-->
<ng-container *notInPopulation="[populations.Free]">
  <div class="mb-3">
    <fgbcl-scorecard-carousel
      [showAllView]="true"
      icon="chevron_right"
      [ngClass]="{ corporate: isCorporate }"
    ></fgbcl-scorecard-carousel>
  </div>
</ng-container>

<div class="d-flex flex-column gap-3">
  <!-- Featured Rewards -->
  <ng-container *ngIf="mixedLoyaltyItems$ | async as mixedLoyaltyItems">
    <div *ngIf="mixedLoyaltyItems.length > 0" class="order-lg-1 order-2">
      <div class="featured-rewards-container pb-2">
        <div class="container">
          <fgbcl-featured-rewards [ngClass]="{ corporate: isCorporate, junior: isJuniorBluebird }"></fgbcl-featured-rewards>
        </div>
      </div>
    </div>
  </ng-container>

  <!--Vouchers-->
  <div class="container order-lg-2 order-1">
    <fgb-vouchers></fgb-vouchers>
  </div>
</div>

<!-- Widgets -->
<ng-container *inPopulation="[populations.JuniorBluebirds]">
  <div class="container widget-container mt-4 d-lg-flex d-none">
    <div class="d-flex align-items-center justify-content-between w-100">
      <a [routerLink]="['/challenges']">
        <img class="widget-img" [src]="'images/challenges-widget.jpg' | contentAssetImage" alt="" />
      </a>
      <a [routerLink]="['/worksheet']">
        <img class="widget-img" [src]="'images/activities-widget.jpg' | contentAssetImage" alt="" />
      </a>
      <a [routerLink]="['/games']">
        <img class="widget-img" [src]="'images/games-widget.jpg' | contentAssetImage" alt="" />
      </a>
    </div>
  </div>
</ng-container>

<!-- Announcements -->
<div class="container">
  <fgbcl-announcements></fgbcl-announcements>
</div>

<!-- Social Media Links -->
<fgb-social-media-links></fgb-social-media-links>
